// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"cf1430ef","453":"3dd3cfc9"}[chunkId] + ".chunk.js";
};